export class HolidayStatsConstants {
    public static readonly WARNING_THREE_MONTHS_LIMIT = 5;
    public static readonly GREEN_SIGNAL_LIMIT = 12;
    public static readonly WARNING_THREE_MONTHS_LIMIT_COLOR = "#ffdd99";
    public static readonly RED_WARNING_COLOR = "#ffbda2";
    public static readonly GREEN_WARNING_COLOR = "#c8f7c8";
    public static readonly LIGHT_GRAY_COLOR = "#efefef";
}
